<img *ngFor="let mediaDetail of data" class="mb-sm" src="{{basePath + mediaDetail.name }}" [alt]="mediaDetail.name" />
